export default __webpack_public_path__ + "static/media/not_found.0c878e46.jpg";